<template>
    <div class="package-item">
        <div class="main-content">
            <img :src="item.iconImg" class="includ_img" alt="" mode="scaleToFill"/>
            <div class="includ_des">
                <div class="includ_title">{{ item.goodsName }}</div>
                <div class="includ_check" v-if="item.type === '3'&&item.specName">服务规格：{{ item.specName }}</div>
                <div class="includ_check" v-if="item.type === '3'&&item.times">服务次数：{{ item.times }}</div>
                <div class="includ_check" v-if="item.type === '1'">权益面额：{{ item.equityValue }}</div>
                <div class="includ_check" v-if="item.type === '1'">权益有效期：{{ item.equityValidity }}</div>
                <div class="includ_check" v-if="item.type === '6'">权益面额：{{ item.schemeValue }}</div>
                <div class="includ_check" v-if="item.type === '6'&&item.schemeDescription">优惠规则：{{ item.schemeDescription }}</div>
                <div class="includ_check" v-if="item.type === '2'">保障额度：{{ item.guaranteeValue }}</div>
                <div class="includ_check" v-if="item.type === '2'">保障期限：{{ item.guaranteeValidity }}</div>
                <div class="includ_check" v-if="item.type === '0'&&item.specName">规格：{{ item.specName }}</div>
                <div class="high-light-box" v-for=" (hl,index) in item.highlights" :key="index">
                    <span class="high-light" v-if="hl">{{ hl }}</span>
                </div>
            </div>
            <div class="include-right">
                <div class="money"><span style="font-size: 0.24rem">¥</span>{{ item.goodsPrice }}</div>
                <div style="color: #666666">x{{ item.numbers }}</div>
            </div>
        </div>
        <div class="tip-box" v-if="item.description">
            <img class="icon-tip" src="../img/ico_tip.svg" alt=""/>
            <span class="tip-content">{{ item.description }}</span>
            <span @click="tipClick" class="tip-tip">详细说明</span>
            <img class="arrow-right" src="../img/arr-rig.svg" alt=""/>
        </div>
    </div>

</template>
<script>

    export default {
        data() {
            return {};
        },
        props: {
            item: Object,
            //1-套餐包详情
            type: {
                type: Number,
                default: 1,
            },
        },
        methods: {
            tipClick() {
                this.$emit('tipClick');
            }
        }
    };
</script>
<style lang="scss">
    .package-item {
        position: relative;
        padding: 0.4rem 0;
        border-top: 0.01rem solid #eee;

        .main-content {
            display: flex;

            .includ_img {
                width: 1.6rem;
                height: 1.36rem;
                margin-right: 0.2rem;
                border-radius: 0.08rem;
            }

            .includ_des {
                flex: 1;

                .includ_title {
                    font-size: 0.3rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 0.3rem;
                    margin-bottom: 0.12rem;
                }

                .includ_check {
                    font-size: 0.24rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 0.4rem;
                }

                .high-light-box {
                    display: flex;
                    flex-wrap: wrap;

                    .high-light {
                        margin-top: 0.12rem;
                        background: rgba(255, 136, 0, 0.07);
                        border-radius: 0.04rem;
                        padding: 0.08rem 0.10rem;
                        max-width: 2.80rem;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;

                        font-size: 0.24rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FF8800;
                        line-height: 0.24rem;
                    }
                }
            }

            .include-right {
                margin-left: 0.50rem;
                text-align: right;

                .money {
                    font-size: 0.36rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #DD2B1E;
                    line-height: 0.36rem;
                }

                .amount {
                    margin-top: 0.16rem;
                    font-size: 0.24rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 0.24rem;
                }
            }

        }

        .tip-box {
            margin-top: 0.24rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            font-size: 0.24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 0.24rem;

            .icon-tip {
                width: 0.24rem;
                height: 0.24rem;
            }

            .tip-content {
                text-align: left;
                flex: 1;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin: 0 0.12rem;
            }

            .arrow-right {
                width: 0.28rem;
                height: 0.28rem;
            }
        }
    }
</style>
